import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";

dayjs.extend(customParseFormat);

// Same status vocabulary and theme-derived colours as wfc-public's incident page
// (incidentReportingDetail.page.jsx), so a status reads identically in both
// portals - the app's teals for the normal flow, orange for "needs attention",
// green/red only for the two final outcomes.
export const INCIDENT_STATUSES = {
    "new":         { label: "New",          color: "#0091ae" },
    "in-review":   { label: "Under review", color: "#e8590c" },
    "in-progress": { label: "In progress",  color: "#126e7d" },
    "on-hold":     { label: "On hold",      color: "#7c98b6" },
    "resolved":    { label: "Resolved",     color: "#16a34a" },
    "closed":      { label: "Closed",       color: "#0d5c63" },
    "rejected":    { label: "Rejected",     color: "#dc2626" },
};

export const CLOSED_INCIDENT_STATUSES = ["resolved", "closed", "rejected"];

export const getStatusMeta = (status) =>
    INCIDENT_STATUSES[status] || { label: status || "New", color: "#6c757d" };

// solid tag, same shape as the Schedules grid's .portal-tag
export const IncidentStatusTag = ({ status }) => {
    const s = getStatusMeta(status);
    return <span className="portal-tag inc-status-tag" style={{ background: s.color }}>{s.label}</span>;
};

export const INCIDENT_TYPES = ["Theft", "Damage", "Assault", "Trespass", "Abuse"];

// The officer's report is stored as flat metadata keys (Workforce360's incident
// form). Known keys get a proper label; anything else falls back to humanizeKey.
export const INCIDENT_FIELD_LABELS = {
    date: "Date of incident",
    time: "Time of incident",
    address: "Address",
    assignment: "Assignment",
    incidentType: "Incident type",
    incidentOutcome: "Outcome",
    incidentDetails: "What happened",
    immediateAction: "Immediate action taken",
    cctv: "CCTV footage available",
    policeAttended: "Police attended",
    policeDetails: "Police details",
    othersInvolved: "Others involved",
    witnesses: "Witnesses",
    signature: "Signed by",
};

export const humanizeKey = (key) =>
    INCIDENT_FIELD_LABELS[key]
    || String(key).replace(/([a-z])([A-Z])/g, "$1 $2").replace(/[_-]+/g, " ").replace(/^./, (c) => c.toUpperCase());

// "N/A", "na", "-", "none" etc. read as "nothing reported" rather than as content
export const isBlankAnswer = (value) =>
    value === undefined || value === null
    || /^\s*(n\/?a|none|nil|nothing|-+|\.)?\s*$/i.test(String(value));

// metadata.date is DD/MM/YYYY and metadata.time is HH:mm, both as typed on mobile
export const formatIncidentWhen = (date, time) => {
    if (!date) return time || "—";
    const parsed = dayjs(`${date} ${time || "00:00"}`, "DD/MM/YYYY HH:mm", true);
    if (!parsed.isValid()) return [date, time].filter(Boolean).join(" ");
    return time ? parsed.format("DD/MM/YYYY HH:mm") : parsed.format("DD/MM/YYYY");
};
